import { render } from "./studentList.vue?vue&type=template&id=30359f4c&scoped=true"
import script from "./studentList.vue?vue&type=script&lang=js"
export * from "./studentList.vue?vue&type=script&lang=js"

import "./studentList.vue?vue&type=style&index=0&id=30359f4c&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30359f4c"]])

export default __exports__